
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { RangeOptions } from "@/types/controls";
import { configStore } from "@/store/store";

@Component
export default class SliderInput extends Vue {
  @Prop()
  value: unknown;

  @Prop({
    default() {
      return {};
    }
  })
  rangeOptions!: RangeOptions;

  get builderMode() {
    return configStore.builderMode;
  }

  get internalValue() {
    if (this.value) return this.value;

    const { min, max } = this.rangeOptions;

    if (typeof min === "number" && typeof max === "number") {
      return [min, max];
    }

    return undefined;
  }

  get labels() {
    return this.rangeOptions.labels || [];
  }

  emit(newVal: unknown) {
    this.$emit("input", newVal);
  }
}
